import { isNumber } from "lodash";
import * as yup from "yup";
import i18n from "~/i18n";

export const recurringTaskValidator = yup.object().shape({
  name: yup.string().required(),
  task_list_id: yup
    .number()
    .test("required-positive-value", i18n.t("There is no task list selected"), (v) => isNumber(v) && v > 0),
});
